import React from 'react'
import '../../styles/LandingPageCss/cta.css' 
import cta from "../../../../../images/LandingPageImage/message_notifier_cta__1x.webp"
import { Link } from 'react-router-dom'
import { useModal } from '../../../../../MyContext'

export default function Cta() {
    const { openModal } = useModal();
    return (
        <div className="cta-wrapper"> 
            <div className="container">
                <section className="cta-section bg-neon-purple ">
                    <div className="row align-items-center justify-content-center text-center text-lg-start">

                        <div className="col-lg-7 text-white px-md-5">
                            <span className="cta-subtitle  text-uppercase">Get Started Now</span>
                            <h2 className="cta-title mt-3">
                                Chat with MsgNotifier AI agent, created with pride using AgentFlow
                            </h2>
                            <div className="d-flex gap-3 mt-4 justify-content-center justify-content-lg-start flex-wrap">
                                <button 
                                onClick={openModal}
                                 className="btn btn-light cta-btn-primary fw-medium hover-scale">
                                    Start Free Trial
                                </button>
                                <Link to="/pricing">
                                <button className="btn btn-outline-light fw-medium cta-btn-secondary">
                                    See Pricing
                                </button>
                                </Link>
                            </div>
                        </div>

                        <div className="col-lg-5 mt-5 mt-lg-0 px-md-4">
                            <div className="cta-image-box d-flex align-items-center justify-content-center shadow-sm">
                                <img src={cta} alt='' className='img-fluid'/>
                            </div>
                        </div>

                    </div>
                </section>
            </div>
        </div>
    )
}